<template lang="pug">
.publish
  .section
    vant-row.light
      vant-col(:span="8") 股票名称
      vant-col.center(:span="8") 截止日期
      vant-col.right(:span="8") 实际披露时间
    vant-row(v-for="(item,i) in publishList" :key="i" type="flex" align="center")
      vant-col(:span="8")
        div {{ item.stock_name }}
        .light {{ item.stock_id }}
      vant-col.center(:span="8") {{ item.end_date }}
      vant-col.right(:span="8" ) {{ item.actual_date }}
</template>

<script>
import { dateToDateStr } from '@utils/time_helper'
import { Row, Col } from 'vant'
import { parseValidRatio, valueColorFormat } from '@utils/values'

export default {
  name: 'Publish',
  components: {
    VantRow: Row,
    VantCol: Col
  },
  props: {
    list: Array
  },
  filters: {
    parseValidRatio,
    valueColorFormat
  },
  computed: {
    publishList() {
      return this.list.map(item => {
        return {
          ...item,
          end_date: dateToDateStr(item.end_date),
          actual_date: item.actual_date ? dateToDateStr(item.actual_date) : '未披露'
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.van-row
  border-bottom 1px solid $border-color
  padding 1rem 0
</style>
